import { GuidT, ValueOf } from '@/types/common';
import { FitT } from '@/constants/fits';
import { TaskStatusT } from '@/constants/statuses';

export const AI_TASK_TYPES = {
    RemoveBg: 'RemoveBg',
    ClothingAttributes: 'ClothingAttributes',
    OutfitTryOn: 'OutfitTryOn',
} as const;

export type AiTaskTypeT = ValueOf<typeof AI_TASK_TYPES>;

export interface CreateAiTaskRequestIF {
    fileGuid?: GuidT;
    outfitGuid?: GuidT;
    taskType: AiTaskTypeT;
}

export interface AiCategoriesIF {
    guid: GuidT;
    name: string;
    raw: string;
    parent: AiCategoriesIF | null;
}

export interface OutputDataIF {
    category: AiCategoriesIF | null;
    color: AiCategoriesIF | null;
    material: AiCategoriesIF | null;
    style?: FitT | null;
}

export interface AiTaskModelIF {
    guid: GuidT;
    inputFileGuid: GuidT | null;
    outputFileGuid: GuidT | null;
    inputOutfitGuid: GuidT | null;
    taskType: AiTaskTypeT;
    status: TaskStatusT;
    createdAt: string;
    startedAt: string | null;
    completedAt: string | null;
    errorMessage: string | null;
    outputData: OutputDataIF | null;
}
